const link = document.querySelector("#monobank-link");

async function requestUrl() {
  const req = await fetch(window.params["ajax_url"], {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      action: "fetch_monobank_url",
    }),
  });
  const res = await req.json();

  if (res.success) {
    return res.data?.pageUrl;
  }
}

async function addUrl() {
  const url = await requestUrl();
  if (url) {
    link.setAttribute("href", url);
  }
}

addUrl();
